<section class="card border mb-5">
  <div class="card-body">
    <h2 class="mb-3">
      {{ 'competitionModule.teamMembers' | translate }}
    </h2>
    <div *ngIf="(team$ | async)?.teamCaptainPersonId">
      <div class="card-subtitle mb-2 h4">
        {{ 'competitionModule.teamCaptain' | translate }}
      </div>

      <p>
        {{
          (memberEntities$ | async)[(team$ | async)?.teamCaptainPersonId]
            ?.firstName
        }}
        {{
          (memberEntities$ | async)[(team$ | async)?.teamCaptainPersonId]
            ?.middleName
        }}
        {{
          (memberEntities$ | async)[(team$ | async)?.teamCaptainPersonId]
            ?.lastName
        }}
      </p>
    </div>
    <div class="card-subtitle mb-2 h4">
      {{ 'competitionModule.staff' | translate }}
    </div>
    <button
      class="btn btn-soft-primary btn-sm"
      (click)="onClickAddStaff()"
      type="button"
    >
      <i
        class="fa fa-user-plus"
        role="img"
        attr.aria-label="{{ 'wcag.addStaff' | translate }}"
      ></i>
    </button>

    <ul class="list-unstyled mt-3 col-md-8 col-lg-6">
      <li
        *ngFor="let staff of competitionStaff$ | async"
        class="d-flex justify-content-between mb-2"
      >
        {{ (memberEntities$ | async)[staff?.memberId]?.firstName }}
        {{ (memberEntities$ | async)[staff?.memberId]?.middleName }}
        {{ (memberEntities$ | async)[staff?.memberId]?.lastName }}

        <button
          type="button"
          *ngIf="(competitionStaff$ | async)?.length"
          (click)="onClickRemoveStaff(staff.id)"
          class="btn btn-soft-primary btn-sm"
        >
          <i
            class="fa fa-user-minus"
            role="img"
            attr.aria-label="{{ 'wcag.removeStaff' | translate }}"
          ></i>
        </button>
      </li>

      <li
        class="d-flex justify-content-between mb-2"
        *ngFor="let invitedStaffMember of invitedStaffMembers$ | async"
      >
        {{ invitedStaffMember.email }}
        <span>
          (
          {{
            (competitionStaffFunctionEntities$ | async)[
              invitedStaffMember.functionId
            ]?.staffFunction
          }}
          )</span
        >

        <button
          type="button"
          *ngIf="(invitedStaffMembers$ | async)?.length"
          (click)="
            onClickRemoveInvitedMember(invitedStaffMember.email, 'staff')
          "
          competition-create-team
          class="btn btn-soft-primary btn-sm"
        >
          <i
            class="fa fa-user-minus"
            role="img"
            attr.aria-label="{{ 'wcag.removeStaff' | translate }}"
          ></i>
        </button>
      </li>
    </ul>

    <div class="card-subtitle mb-2 h4">
      {{ 'competitionModule.players' | translate }}
    </div>
    <button
      class="btn btn-soft-primary btn-sm"
      (click)="onClickAddPlayer()"
      type="button"
    >
      <i
        class="fa fa-user-plus"
        role="img"
        attr.aria-label="{{ 'wcag.addPlayer' | translate }}"
      ></i>
    </button>

    <p
      *ngIf="
        (competitionSport$ | async)?.teamMinPlayers &&
        (competitionSport$ | async)?.teamMinPlayers > 0
      "
      class="text-muted font-italic small mb-0 mt-3"
    >
      {{ 'competitionModule.signUpLeast' | translate
      }}{{ (competitionSport$ | async).teamMinPlayers }}&nbsp;{{
        'competitionModule.players' | translate
      }}
    </p>
    <p
      *ngIf="
        (competitionSport$ | async)?.teamMaxPlayers &&
        (competitionSport$ | async)?.teamMaxPlayers > 0
      "
      class="text-muted font-italic small mb-0"
    >
      {{ 'competitionModule.signUpMax' | translate
      }}{{ (competitionSport$ | async).teamMaxPlayers }}&nbsp;{{
        'competitionModule.players' | translate
      }}
    </p>

    <ul class="list-unstyled mt-3 col-md-8 col-lg-6">
      <li
        *ngFor="let player of competitionPlayers$ | async"
        class="d-flex justify-content-between mb-2"
      >
        {{ [player?.number] }}
        {{ (memberEntities$ | async)[player?.memberId]?.firstName }}
        {{ (memberEntities$ | async)[player?.memberId]?.middleName }}
        {{ (memberEntities$ | async)[player?.memberId]?.lastName }}

        <button
          *ngIf="(competitionPlayers$ | async)?.length"
          (click)="onClickRemovePlayer(player.id)"
          competition-create-team
          class="btn btn-soft-primary btn-sm"
          type="button"
        >
          <i
            class="fa fa-user-minus"
            role="img"
            attr.aria-label="{{ 'wcag.removePlayer' | translate }}"
          ></i>
        </button>
      </li>
      <li
        *ngFor="let invitedPlayer of invitedPlayers$ | async"
        class="d-flex justify-content-between mb-2"
      >
        {{ invitedPlayer.number }}
        {{ invitedPlayer.email }}

        <button
          *ngIf="(invitedPlayers$ | async)?.length"
          (click)="onClickRemoveInvitedMember(invitedPlayer.email, 'player')"
          competition-create-team
          class="btn btn-soft-primary btn-sm"
          type="button"
        >
          <i
            class="fa fa-user-minus"
            role="img"
            attr.aria-label="{{ 'wcag.removePlayer' | translate }}"
          ></i>
        </button>
      </li>
    </ul>
  </div>
  <!-- End Body -->
</section>
